import "./LoginEmpresa.css";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "/api";

const getPublicAssetUrl = (path) => {
  if (!path || typeof path !== "string") {
    return "";
  }

  return path.startsWith("http")
    ? path
    : `${API_URL}${path}`;
};

function LoginEmpresa() {
  const { company } = useParams();

  const [companyValid, setCompanyValid] = useState(null);
  const [companyData, setCompanyData] = useState(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  useEffect(() => {
    const checkCompany = async () => {
      try {
        setCompanyValid(null);

        const response = await axios.get(
          `${API_URL}/companies/by-subdomain/${encodeURIComponent(
            company
          )}/branding`
        );

        setCompanyData(response.data);
        setCompanyValid(true);
      } catch (error) {
        console.error(error);
        setCompanyData(null);
        setCompanyValid(false);
      }
    };

    checkCompany();
  }, [company]);

  useEffect(() => {
    if (!companyData?.favicon) {
      return;
    }

    const faviconUrl = getPublicAssetUrl(
      companyData.favicon
    );

    let favicon = document.querySelector(
      "link[rel~='icon']"
    );

    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }

    favicon.href = faviconUrl;
  }, [companyData]);

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      setLoggingIn(true);

      const response = await axios.post(
        `${API_URL}/auth/login-company`,
        {
          email: email.trim(),
          password,
          subdomain: company,
        }
      );

      localStorage.setItem(
        "company_token",
        response.data.access_token
      );

      localStorage.setItem(
        "company_info",
        JSON.stringify({
          ...response.data,
          logo: companyData?.logo || null,
          favicon: companyData?.favicon || null,
          primary_color:
            companyData?.primary_color || "#1f5d7a",
          secondary_color:
            companyData?.secondary_color || "var(--company-secondary)",
        })
      );

      toast.success(
        `Bienvenido a ${response.data.company_name}`
      );

      window.setTimeout(() => {
        window.location.href = `/${company}/dashboard`;
      }, 800);
    } catch (error) {
      console.error(error);

      toast.error(
        error.response?.data?.detail ||
          "Error al iniciar sesión."
      );
    } finally {
      setLoggingIn(false);
    }
  };

  if (companyValid === null) {
    return (
      <div className="company-loading">
        <h2>Cargando empresa...</h2>
      </div>
    );
  }

  if (companyValid === false) {
    return (
      <div className="company-loading">
        <h2>Empresa no encontrada</h2>
      </div>
    );
  }

  const companyName =
    companyData?.commercial_name ||
    companyData?.company_name ||
    "Empresa";

  const logoUrl = getPublicAssetUrl(
    companyData?.logo
  );

  return (
    <div
      className="company-page"
      style={{
        "--company-primary":
          companyData?.primary_color || "var(--company-primary)",
        "--company-secondary":
          companyData?.secondary_color || "var(--company-secondary)",
        "--company-login-background":
          companyData?.login_background_color ||
          "#eef2ff",
      }}
    >
      <div className="company-container">
        <div className="company-sign-in">
          <form onSubmit={handleLogin}>
            <h1>{companyName}</h1>

            <span>
              Inicia sesión para acceder a tu empresa
            </span>

            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(event) =>
                  setEmail(event.target.value)
                }
                required
              />

              <label>Correo electrónico</label>
            </div>

            <div className="input-group">
              <input
                type="password"
                value={password}
                onChange={(event) =>
                  setPassword(event.target.value)
                }
                required
              />

              <label>Contraseña</label>
            </div>

            <a
              href="/recuperar-password"
              className="forgot-password"
            >
              ¿Olvidaste tu contraseña?
            </a>

            <button
              type="submit"
              disabled={loggingIn}
            >
              {loggingIn
                ? "Ingresando..."
                : "Ingresar"}
            </button>
          </form>
        </div>

        <div className="company-info">
          <div className="company-info-content">
            <div className="login-right">
              <div className="company-brand">
                {logoUrl ? (
                  <img
                    src={logoUrl}
                    alt={`Logo de ${companyName}`}
                    className="company-logo"
                  />
                ) : (
                  <div className="company-logo-placeholder">
                    {companyName.charAt(0).toUpperCase()}
                  </div>
                )}

                <p>
                  Bienvenido a tu plataforma empresarial.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginEmpresa;